import React from "react"
import portfolioStyles from "./portfolio.module.scss"
import { Link } from "gatsby"

const Portfolio = () => {
  return (
    <section className={portfolioStyles.portfolio} id="portfolio">
      <div className={portfolioStyles.linkbox}>
        <div className={portfolioStyles.linkbox__item_1}>
          <div className={portfolioStyles.linkbox__item_1__label_1}>
            <p>PORTRETY</p>
            <img
              className={portfolioStyles.line_small_vl}
              src={require("../img/line_small_vl.svg")}
              alt="hero-img"
            ></img>
          </div>
          <Link to="/portrety">
            <img src={require("../img/portrety.png")} alt="hero-img"></img>
          </Link>
        </div>
        <div className={portfolioStyles.linkbox__item_2}>
          <div className={portfolioStyles.linkbox__item_2__label_2}>
            <p>ZAKOCHANI</p>
            <img src={require("../img/line_small_hr.svg")} alt="hero-img"></img>
          </div>
          <Link to="/zakochani">
            <img src={require("../img/zakochani.png")} alt="hero-img"></img>
          </Link>
        </div>
        <div className={portfolioStyles.linkbox__item_3}>
          <div className={portfolioStyles.linkbox__item_3__label_3}>
            <p>MOJE INWENCJE</p>
            <img src={require("../img/line_small_hr.svg")} alt="hero-img"></img>
          </div>
          <Link to="/moje_inwencje">
            <img src={require("../img/inne.png")} alt="hero-img"></img>
          </Link>
        </div>
      </div>
    </section>
  )
}
export default Portfolio
